<template>
    <NuxtLink v-if="isFilled.contentRelationship(content) && content.data" :to="resolvePrismicLink(content)" class="selection-card">
        <PrismicImage :field="content.data.thumbnail" :imgix-params="{w: 700}" />
        <div class="hover-cta">
            <span>{{ t('resources.ctas.read') }}</span>
        </div>

        <div class="article-text">
            <p class="resource-type">{{ t(`resources.${content.type}`) }}</p>
            <h3 class="title">{{ content.data.title }}</h3>
        </div>
    </NuxtLink>
</template>

<script lang="ts" setup>
    import {isFilled} from '@prismicio/helpers';
    import type {ContentRelationshipField} from '@prismicio/types';
    import {PrismicImage} from '@prismicio/vue';
    import type {ArticleDocumentData, GuideDocumentData, SuccessStoryDocumentData} from '@prismicio-types';
    import {useLinkHelper, useTranslation} from '#imports';

    defineProps<{
        content:
            | ContentRelationshipField<'article', string, ArticleDocumentData>
            | ContentRelationshipField<'guides', string, GuideDocumentData>
            | ContentRelationshipField<'successStories', string, SuccessStoryDocumentData>;
    }>();
    const {resolvePrismicLink} = useLinkHelper();
    const {t} = useTranslation();
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .selection-card {
        width: auto;
        display: flex;
        flex-direction: column;
        position: relative;

        img {
            width: 100%;
            height: 240px;
            object-fit: contain;
            object-position: center bottom;

            @media (max-width: $mobile-breakpoint) {
                height: 140px;
            }
        }

        .hover-cta {
            position: absolute;
            top: 110px;
            left: 50%;
            transform: translateX(-50%) rotateZ(-8deg);
            padding: 5px 10px 3px;
            border-radius: var(--joy-core-radius-2);
            background-color: var(--joy-color-primary-50);
            z-index: 2;
            opacity: 0;
            transition: opacity var(--joy-transition-duration-default) var(--joy-transition-timing-function);

            span {
                font-family: var(--joy-font-family-title);
                font-size: var(--joy-font-size-primary-600);
                line-height: var(--joy-line-height-small);
                color: var(--joy-color-neutral-0);
            }
        }

        &:hover {
            .hover-cta {
                opacity: 1;
            }
        }

        .article-text {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
        }

        .resource-type {
            font-family: var(--joy-font-family-title);
            font-size: var(--joy-font-size-primary-400);
            font-weight: 800;
            line-height: var(--joy-line-height-small);
            color: var(--joy-color-primary-50);
            margin-top: var(--joy-core-spacing-5);
            text-transform: uppercase;
        }

        .title {
            margin-top: var(--joy-core-spacing-4);
        }
    }
</style>
